import React from "react";
import { AspectRatio, Box, Flex } from "@chakra-ui/react";
import { BookDemoButton } from "components/event-tracking/book-demo-button";
import { Section } from "components/section";
import { TextTitle } from "ui/text";
import { FadeIn } from "ui/animations";
import { AnimationVideo } from "ui/animation-video";

const videoWebm = "https://cdn.sanity.io/files/pwmfmi47/production/ed41c60e8b4ccacbc687de1c5446587d4b3544ac.webm";
const videoMp4 = "https://cdn.sanity.io/files/pwmfmi47/production/f6c920f09d26bd0163ef308d6b842dcfd97a68a2.mp4";
const videoPoster =
  "https://cdn.sanity.io/images/pwmfmi47/production/dc892e179375216879e9071dbfbf8a4875fec9ca-3436x1926.webp";

type HomeHeroProps = {
  title: string;
  description: string;
};

export function HomeHero({ title, description }: HomeHeroProps) {
  return (
    <Section bg="new.blue.50" themeBgColor="new.blue.50" py={0} pos="relative" overflow="hidden">
      <Box>
        <FadeIn duration={0.4}>
          <Box pos="relative" overflow="visible" pt={{ base: "big", md: "biggest" }}>
            <Box
              // Ensure the text sits above the aura bg image
              pos="relative"
              zIndex={10}
            >
              <TextTitle
                size="2xl"
                align="center"
                mobileAlign="center"
                title={title}
                titleAs="h1"
                maxW="980px"
                descriptionMaxW="900px"
                description={description}
                descriptionAs="h2"
                actions={
                  <Box>
                    <BookDemoButton pulse="light" />
                  </Box>
                }
              />
            </Box>

            <Flex
              align="center"
              justify="center"
              pos="relative"
              // Overflow="visible"
              pt="bigger"
              pb={{ base: "biggest", md: "huge" }}
              pointerEvents="none"
              userSelect="none"
              w="100%"
            >
              <AspectRatio
                ratio={16 / 9}
                w="100%"
                borderRadius={{ base: "small", md: "big" }}
                maxW={{ base: "mediaMaxW.mobile", md: "1080px" }}
                mx="auto"
                overflow="hidden"
              >
                <AnimationVideo
                  hideControls
                  isLooped
                  webm={videoWebm}
                  mp4={videoMp4}
                  poster={videoPoster}
                  viewportAmount={0.5}
                />
              </AspectRatio>
            </Flex>
          </Box>
        </FadeIn>
      </Box>
    </Section>
  );
}
